document.addEventListener("DOMContentLoaded", function () {
  console.log("CH Preorder Button Logic Loaded");

  function safeJSONParse(text, context) {
    if (!text || typeof text !== "string") return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      console.warn("CH Preorder: Failed to parse JSON for", context || "unknown", e);
      return null;
    }
  }

  function getMarketFromRoot(productRoot) {
    if (productRoot) {
      var attr = productRoot.getAttribute("data-market-handle");
      if (attr) {
        return String(attr).toLowerCase();
      }
    }
    try {
      if (window.Shopify && Shopify.country) {
        return String(Shopify.country).toLowerCase();
      }
    } catch (e) {
      // ignore
    }
    return null;
  }

  function getVariantFromScript(productRoot) {
    if (!productRoot) return null;

    var productInfo = productRoot.closest("product-info") || productRoot.closest("[data-section-id]") || document;
    var selectedScript = productInfo.querySelector("script[data-selected-variant]");
    if (!selectedScript || !selectedScript.textContent) {
      return null;
    }
    return safeJSONParse(selectedScript.textContent, "selected variant script");
  }

  function normalizePreorderMarkets(variant) {
    var results = [];
    if (!variant || !variant.metafields || !variant.metafields.custom) {
      return results;
    }

    var m = variant.metafields.custom.preorder_markets;
    if (!m) return results;

    function pushValue(v) {
      if (v === null || v === undefined) return;
      var s = String(v).trim();
      if (!s) return;
      results.push(s.toLowerCase());
    }

    if (Array.isArray(m)) {
      m.forEach(function (entry) {
        if (typeof entry === "string") {
          pushValue(entry);
        } else if (entry && typeof entry === "object") {
          pushValue(entry.value || entry.handle || entry.key);
        }
      });
      return results;
    }

    if (typeof m === "object" && m.value !== undefined) {
      var mv = m.value;
      if (Array.isArray(mv)) {
        mv.forEach(function (entry) {
          if (typeof entry === "string") {
            pushValue(entry);
          } else if (entry && typeof entry === "object") {
            pushValue(entry.value || entry.handle || entry.key);
          }
        });
      } else if (typeof mv === "string") {
        mv.split(/[,\s]+/).forEach(pushValue);
      } else {
        pushValue(mv);
      }
      return results;
    }

    if (typeof m === "string") {
      m.split(/[,\s]+/).forEach(pushValue);
    } else {
      pushValue(m);
    }

    return results;
  }

  function isPreorder(productRoot, variant) {
    if (!variant) return false;

    if (productRoot && productRoot.getAttribute("data-bundle-single") === "true") {
      return false;
    }

    if (variant.inventory_management !== "shopify") return false;

    if (typeof variant.inventory_quantity === "number" && variant.inventory_quantity > 0) {
      return false;
    }

    if (variant.inventory_policy !== "continue") return false;

    var market = getMarketFromRoot(productRoot);
    if (!market) return false;

    var markets = normalizePreorderMarkets(variant);
    if (!markets || !markets.length) return false;

    return markets.indexOf(market) !== -1;
  }

  function updateButton(productRoot, variantOverride) {
    if (!productRoot) return;

    var btn = productRoot.querySelector('button[type="submit"]');
    if (!btn) return;

    var labelContainer =
      btn.querySelector(".btn-text > span") ||
      btn.querySelector(".btn-text") ||
      btn;

    var defaultLabel = btn.getAttribute("data-add-to-cart-label") || "Add to cart";
    var preorderLabel = btn.getAttribute("data-preorder-label") || "Pre-Order";
    var soldOutLabel = btn.getAttribute("data-sold-out-label") || "Out of stock";

    var variant = variantOverride || getVariantFromScript(productRoot);
    if (!variant) {
      console.log("CH Preorder: No active variant resolved for", productRoot);
      return;
    }

    var preorder = isPreorder(productRoot, variant);

    console.log("CH Preorder: updateButton → variant id:", variant.id, "preorder:", preorder);

    if (preorder) {
      labelContainer.textContent = preorderLabel;
      btn.disabled = false;
      productRoot.setAttribute("data-preorder-active", "true");
    } else {
      productRoot.removeAttribute("data-preorder-active");

      if (variant.available === false) {
        labelContainer.textContent = soldOutLabel;
        btn.disabled = true;
      } else {
        labelContainer.textContent = defaultLabel;
        btn.disabled = false;
      }
    }
  }

  var roots = document.querySelectorAll("[data-product-form-root]");
  if (!roots || !roots.length) {
    console.log("CH Preorder: No [data-product-form-root] found.");
    return;
  }

  roots.forEach(function (productRoot) {
    console.log("CH Preorder: bound to root", productRoot);

    var productForm =
      productRoot.querySelector('form[is="product-form"]') ||
      productRoot.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      productForm.addEventListener("variant:change", function (event) {
        var variantFromEvent =
          event && event.detail && event.detail.variant ? event.detail.variant : null;
        console.log("CH Preorder: variant:change event received", variantFromEvent);
        updateButton(productRoot, variantFromEvent);
      });
    }

    productRoot.addEventListener("change", function (e) {
      if (!e || !e.target) return;

      var nameAttr = e.target.name || "";
      if (nameAttr === "id" || nameAttr.indexOf("options[") === 0) {
        console.log("CH Preorder: change event from", nameAttr);
        setTimeout(function () {
          updateButton(productRoot);
        }, 30);
      }
    });

    updateButton(productRoot);
  });
});
